/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import type { MouseEventHandler } from "react";
import { Flex, Typography } from "../../..";
import { optionItemBaseButtonCSS } from "../OptionItem.css";
import type { OptionItemBaseProps } from "../OptionItem.types";

export const OptionItemBaseCore = ({
  text,
  size,
  suffix,
  onClickSuffix,
  isDisabled,
}: OptionItemBaseProps) => {
  const _onClickSuffix: MouseEventHandler = (event) => {
    event.stopPropagation();
    onClickSuffix?.();
  };

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      gap={vars.spacing[3]}
      css={[
        optionItemBaseButtonCSS({ size }),
        {
          color: "inherit",
        },
      ]}
    >
      <Typography variant="label-medium" sx={{ color: "inherit" }}>
        {text}
      </Typography>

      {suffix && (
        <div
          aria-hidden
          onClick={_onClickSuffix}
          css={{
            color: vars.semantic.color[isDisabled ? "textDisabled" : "textSub"],
            display: "flex",
            ...vars.semantic.typography["label-small"],
          }}
        >
          {suffix}
        </div>
      )}
    </Flex>
  );
};
